import { inject, Injectable } from '@angular/core';
import { FwSnackbarService } from '@flywheel-io/vision';
import get from 'lodash/get';

import { notifications } from './common/notifications/notifications.config';

export type NotificationLevel = 'info' | 'success' | 'warning' | 'error';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private snackbarService = inject(FwSnackbarService);

  success(input: string, isRawMessage?: boolean): void {
    this.show(this.getNotification(input, isRawMessage), 'success');
  }

  warning(input: string, isRawMessage?: boolean): void {
    this.show(this.getNotification(input, isRawMessage), 'warning');
  }

  error(input: string, isRawMessage?: boolean, id?: string, duration?: number): void {
    this.show(this.getNotification(input, isRawMessage,), 'error', id, duration);
  }

  show(message: string, type: NotificationLevel, id?: string, duration?: number): void {
    this.snackbarService.show({
      severity: type,
      message: message,
      id,
      duration,
    })
  }

  dismiss(id: string): void {
    this.snackbarService.dismiss(id);
  }

  getNotification(input: string, isRawMessage = false): string {
    let message: string;

    if (isRawMessage) {
      message = input;
    } else {
      message = get(notifications, input, 'Unable to load notification.');
    }

    return message;
  }
}
